module.exports = __webpack_public_path__ + "img/logo.79bf1b7d.svg";